export default __webpack_public_path__ + "static/media/change-field-light.7a7910b4.svg";